import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PrintProviderId = Brand<number, 'PrintProviderId'>;
export const PrintProviderId = createBranded<PrintProviderId>();
